import { connect } from 'react-redux';

import { getPostList, getPostDetail } from '../../actions';
import { PostListView } from './view';

const mapStateToProps = (state) => {
    return {
        postList: state.postList
    };
};

const mapDispatchToProps = {
    getPostList,
    getPostDetail
};

export const PostList = connect(mapStateToProps, mapDispatchToProps)(PostListView);
